import { render } from "./SelectButton.vue?vue&type=template&id=46edff68"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__